
import qrImage from '../assets/qr.png';
import waNumber from '../assets/wa-number.jpeg'
import waPic from '../assets/wa-image.jpeg'
import nope from '../assets/hopes.png';

const FAQModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Frequently Asked Questions</h3>
          <button className="close-modal" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="faq-content">
            <div className="faq-item">
              <h4>What is the NBLR Milestone Challenge?</h4>
              <p>The challenge is simple: each month in 2026, run either a 10 mile or 20 mile route. Each qualifying run must use totally unique trails to promote a year of exploration and finding new, cool places to run. Complete all 12 months and earn yourself a special medal at the end of the year!

</p>
                
            
            </div>
            <div className="faq-item">
              <h4 className='how'>How do I participate?</h4>
              <h4 class="subColour">Simply:</h4>
              <p>Add +447488896813 to your phone and WhatsApp a picture or Strava screebgrab of your run each month to it to get the tick.</p>
              <h4 class="subColour">In more detail:</h4>
              <br/> <br/>
              <h4>1. Register - (The deadline for registration has now passed)</h4>
              <p>Firstly you'll need to <a href="/register">register</a> so we can add your name to the table below.</p>
              <h4>2. Add our WhatsApp number +447488896813</h4>
              <p>You'll neeed to add our WhatsApp number to the contacts on your phone so its ready to use in WhatsApp. Scan the QR code below
              or if you're on your phone now <a href="https://wa.me/447488896813">click this link</a>, or just add this number manually +447488896813. This is not a WhatsApp group, it's our number that you need to send the image to.</p>
              <p><img src={qrImage} className="qrImage" alt="Scan this on your phone"/> </p>
              <h4>3. WhatsApp us a picture or screengrab every month</h4>
              <p>At the very minium you need to send us a strava screengrab or picture you took on the run. By submitting either of these you are confirming you completed that months run. If you wish you can include a brief comment with the image which is then shown on the website.</p>
              <p><img src={waNumber} className="demoImage" alt="Scan this on your phone"/><br /><img src={waPic} className="demoImage" alt="Scan this on your phone"/></p>

              <h4>The challenge rules:</h4>
              <ul>
                <li>You must complete at least one 10-mile or 20-mile run each month in 2026.</li>
                <li>You may not repeat any sections of trail, though you are allowed to cross them. This means no out-and-back routes.</li>
                <li>When you complete a route you can Whatsapp a screengrab of your Strava or a photo you took whilst running (like the Advent challenge).</li>
                <li>If you complete all 12 routes (one each month) you will receive a special medal at the end of the year.</li>
              </ul>
              <img src={nope} className="demoImagewide" alt="Rules be rules boy"/>
                          </div>
                           <div className="faq-item">
              <h4>What happens if I make a mistake with my submission?</h4>
              <p>If you make a mistake with a submission, just send it again and it will overwrite your last one for that month.</p>
            </div>
            <div className="faq-item">
              <h4>Can I miss a month?</h4>
              <p>No, you must run at least one 10 or 20 mile run (depending on the category you entered) each month.</p>
            </div>
             <div className="faq-item">
              <h4>Is there a deadline for submitting mileage each month?</h4>
              <p>Yes, mileage must be submitted before midnight on the last day of the month.</p>
            </div>
            <div className="faq-item">
              <h4>Are submissions monitored?</h4>
              <p>No, we rely on an honesty systemn and submissions are self-reported by participants and displayed in the table.</p>
              <p>All images are monitored, and any image deemed unsuitable will be removed. The participant may also be removed.</p>
            </div>
            <div className="faq-item">
            <h4>Milestone Running Challenge – Safety Statement</h4>
            <p>This Milestone Challenge is a fun, informal activity open to runners of all levels. By taking part, you agree to take full responsibility for your own safety and wellbeing throughout the challenge. Please choose routes and conditions that are appropriate for your ability, stay aware of your surroundings, and use sensible precautions—especially in winter weather and low light. If it's better for you to run indoors on the treadmill, that's cool with us.</p>

            <p>Participation is completely voluntary, and you should only run if you feel fit, healthy and able to do so safely. The organisers cannot accept liability for any injury, loss, or damage that may occur.</p>

            <p>Above all, enjoy yourself, look after one another, and have fun!</p>
            </div>
             <div className="faq-item">
              <h4>How can I get in touch?</h4>
              <p>You can email us - <a href="mailto:info@nblrs.co.uk">info@nblrs.co.uk</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQModal;